var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2167_2193",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2167_2193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.981 18.7917C8.99615 18.7917 7.26624 18.1382 5.79133 16.8314C4.31641 15.5245 3.46735 13.8863 3.24414 11.9167H4.64733C4.87879 13.4998 5.59127 14.8122 6.78477 15.854C7.97811 16.8958 9.37687 17.4167 10.981 17.4167C12.7685 17.4167 14.2849 16.7941 15.53 15.549C16.7751 14.3038 17.3977 12.7875 17.3977 11C17.3977 9.21251 16.7751 7.69619 15.53 6.45105C14.2849 5.20591 12.7685 4.58334 10.981 4.58334C9.97973 4.58334 9.04137 4.80579 8.16595 5.25068C7.29038 5.69541 6.53643 6.30736 5.90408 7.08653H8.30162V8.46153H3.6477V3.80761H5.0227V5.97943C5.76658 5.10157 6.65743 4.42025 7.69525 3.93549C8.73291 3.45073 9.82818 3.20834 10.981 3.20834C12.0622 3.20834 13.0753 3.41284 14.0202 3.82182C14.965 4.23081 15.7888 4.78669 16.4916 5.48947C17.1944 6.19225 17.7502 7.0161 18.1592 7.96103C18.5682 8.90581 18.7727 9.9188 18.7727 11C18.7727 12.0812 18.5682 13.0942 18.1592 14.039C17.7502 14.9839 17.1944 15.8078 16.4916 16.5106C15.7888 17.2133 14.965 17.7692 14.0202 18.1782C13.0753 18.5872 12.0622 18.7917 10.981 18.7917ZM13.7329 14.6914L10.3201 11.2784V6.41668H11.6949V10.7216L14.6988 13.7253L13.7329 14.6914Z",
    fill: "#155DFC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.99a69e43372ae71c3ad889551a3f515b.svg";
export { ForwardRef as ReactComponent };